import $ from "jquery/dist/jquery";

$(() => {
  $(document).on("eshop:add", function (e, data) {
    if (window?.NXCMS_ESHOP_GTM && window.dataLayer) {
      return;
    }
    if (data.products) {
      let items_data = [];
      let value = 0;
      for (let i = 0; i < data.products.length; i++) {
        let product = data.products[i];
        let d = {
          item_id: product.item_id,
          item_name: product.name,
          item_category: product.category,
          item_brand: product.manufacturer,
          price: product.price_wo_vat,
          quantity: product.quantity,
        };
        items_data.push(d);
        value += product.quantity * product.price_wo_vat;
      }

      window.gtag?.("event", "add_to_cart", {
        currency: window.NXMOD.CURRENCY ? window.NXMOD.CURRENCY : "CZK",
        value: value,
        items: items_data,
      });

      window.gtag?.("event", "ux_click", {
        name: "přidáno do košíku",
      });
    }
  });
});
